import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  onClick: () => void;
}

export default function AddAccountCard({ onClick }: Props) {
  const intl = useIntl();

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={intl.formatMessage({ id: 'accounts.list.create' })}
      className="flex items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-slate-300 p-5 text-sm font-medium text-slate-500 transition hover:border-brand-400 hover:text-brand-600 focus:outline-none"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
      </svg>
      <FormattedMessage id="accounts.list.create" />
    </button>
  );
}
